export default "__VITE_ASSET__BuRDvdWR__"